import { ThemeProvider } from "@material-ui/core/styles";
import * as React from 'react'

import theme from './themeBuilder'

const AMSTheme = (props: React.PropsWithChildren<{}>) => {
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
}

export default AMSTheme